import type { AppRouter } from "@lattice/backend/trpc";
import { createTRPCReact } from "@trpc/react-query";

export const trpcApi = createTRPCReact<AppRouter>({});
